import makeStyles from '@material-ui/core/styles/makeStyles';
import { ERebrandingFonts } from 'helpers/constants';

const styles = makeStyles((theme) => ({
  modal: {
    fontFamily: ERebrandingFonts.OPENSANS,
  },
  paper: {
    overflowY: 'visible',
  },
  title: {
    fontSize: 20,
    fontWeight: 600,
    lineHeight: '120%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: 24,
    paddingBottom: 16,
  },
  closeButton: {
    cursor: 'pointer',
    '& > span': { display: 'block' },
  },
  boxContentText: {
    fontFamily: 'inherit',
    margin: '0',
  },
  buttonGroup: {
    padding: '8px 24px 24px',
    gap: '8px',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  proceedButton: {
    fontWeight: 600,
    fontSize: '0.875rem',
    lineHeight: '150%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginLeft: 'unset !important',
    },
    [theme.breakpoints.up('md')]: {
      minWidth: 100,
    },
  },
  returnButton: {
    lineHeight: '150%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    [theme.breakpoints.up('md')]: {
      marginLeft: '32px',
    },
  },
}));

export default styles;
